import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';
import { PackageDataService } from './package.service';
import { SelectItem } from 'primeng/api';
import { ClientDataService } from './client.service';
import { ShipmentDataService } from './shipment.service';
import { LookupService } from './lookup.service';

@Injectable({
   providedIn: 'root'
})
export class PackageReceiveService {

   constructor(private httpClient: HttpClient,
      private configService: ConfigService,
      private clientDataService: ClientDataService,
      private packageService: PackageDataService,
      private lookupService: LookupService) {

      this.packageService.getShipmentTypes().subscribe((data: any) => {
         this.shipmenttypes = data.map(d => <any>{ label: d.Name, value: d.Code.trim(), selected: false });
      });

      this.lookupService.getStates().subscribe((data: any) => {
         this.states = data.map(d => <SelectItem>{ label: d.Description, value: d.Code });
      });

   }

   public addressBypassed: boolean = false;
   public stepnumber: number = 1;
   public trackingNumber: string;
   public shipper: any;
   public client: any;
   public dateDelivered: any;
   public packageFound: boolean;
   public cantChangeShipper: boolean;
   public states: SelectItem[];
   public shipmenttypes: any[];

   //package properties
   public Id: number = 0;
   public ClientId: any = null;
   public DeliveredDate: Date;
   public ShipmentType: string;
   public FromName: string;
   public shipmentTypeDisplay: any = null;
   public FromAddress1: string;
   public FromCity: string;
   public FromState: string;
   public FromZipCode: string;

   public findClientByAddress(callback) {
      this.clientDataService.searchByLocation(this.FromAddress1, this.FromCity, this.FromState, this.FromZipCode).subscribe((data: any) => {
         for (var i = 0; i < data.length; i++) {
            if (data[i].DistanceInMiles == 0) {
               var tmp = data[i].Name + " (" + data[i].DistanceInMiles + " miles)";
               data[i].OriginalName = data[i].Name;
               data[i].Name = tmp;
               data[i].selected = false;
               this.client = data[i];

               if (callback) {
                  callback();
               }
               return;
            }
         }
         if (callback) {
            callback();
         }
      });
   }

   public findShipmentTypeDisplay() {
      for (var i = 0; i < this.shipmenttypes.length; i++) {
         if (this.shipmenttypes[i].value == this.ShipmentType) {
            this.shipmentTypeDisplay = this.shipmenttypes[i].label;
            return;
         }
      }
   }

   public reset() {
      this.Id = 0;
      this.ClientId = null;
      this.trackingNumber = "";
      this.shipper = null;
      this.client = null;
      this.dateDelivered = null;
      this.packageFound = false;
      this.cantChangeShipper = false;
      this.DeliveredDate = null;
      this.ShipmentType = "FEDEX";
      this.FromName = "";
      this.shipmentTypeDisplay = "";
      this.FromAddress1 = "";
      this.FromCity = "";
      this.FromState = "";
      this.FromZipCode = "";
      this.addressBypassed = false;
   }

   public model() {
      return {
         "Id": this.Id,
         "ClientId": this.ClientId,
         "LabId": 1,
         "TrackingNumber": this.trackingNumber,
         "DeliveredDate": this.DeliveredDate,
         "ShipmentType": this.ShipmentType,
         "FromName": this.FromName,
         "FromAddress1": this.FromAddress1,
         "FromCity": this.FromCity,
         "FromState": this.FromState,
         "FromZipCode": this.FromZipCode
      };
   }
}
